import React from 'react';
import { Link } from 'react-router-dom';

const FieldSupportSideBarItem = ({ url, name }) => {
  return (
    <li className="s-sidebar__nav-link">
      {' '}
      <Link to={url} target="_self">
        <span>
          <img src="https://res.cloudinary.com/teewhy/image/upload/v1549268125/Installationzone.fw.png" alt="img" />
        </span>
        <small>{name}</small>
      </Link>
    </li>
  );
};

export default FieldSupportSideBarItem;
